var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g-sales-counter',{attrs:{"action-hooks":"updateSalesCounter"}})
}
var staticRenderFns = []

export { render, staticRenderFns }